import React from "react";
import styles from "./ui-element.module.scss";
import { DatePickerComponent } from "../form";

const StudentProfileInput = ({
  topLabel,
  placeholder,
  required = false,
  inputType,
  label = "block",
  ...rest
}) => {
  if (inputType == "date") {
    return (
      <div className={styles.student_profile_input}>
        <label className={styles.label} style={{ display: label }}>
          {topLabel} {required && <span>*</span>}
        </label>
        <DatePickerComponent
          placeholder={placeholder ? placeholder : "yyyy-mm-dd"}
          {...rest}
          className="bordered_datepicker"
        />
      </div>
    );
  }

  return (
    <div className={styles.student_profile_input}>
      <label className={styles.label}>
        {topLabel} {required && <span>*</span>}
      </label>
      <input
        type={inputType}
        placeholder={placeholder && placeholder}
        {...rest}
        autoComplete="false"
        onWheel={() => document.activeElement.blur()}
      />
    </div>
  );
};

export default StudentProfileInput;
